import { Places } from '../../Constants'
import { MainKeys } from '../../main/Main.keys'

export class SerproKeys extends MainKeys {
    get place() {
        return Places.serpro
    }
}

export default SerproKeys
